import { jsx } from "react/jsx-runtime";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import { validateTidalLicense } from "../../base/index.js";
function SentimentVeryDissatisfied(props) {
  return /* @__PURE__ */ jsx(
    SentimentVeryDissatisfiedIcon,
    {
      "data-testid": "SentimentVeryDissatisfied",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SentimentVeryDissatisfied",
      "data-tidal-icon-meta": "ratings,sentiments"
    }
  );
}
SentimentVeryDissatisfied.tidalIconMeta = {
  categories: "ratings,sentiments",
  name: "SentimentVeryDissatisfied"
};
validateTidalLicense();
export {
  SentimentVeryDissatisfied
};
//# sourceMappingURL=SentimentVeryDissatisfied.js.map
